<template>
  <div>
    <div class="role_list" v-for="(el, index) in menuList" :key="el.auth">
      <div class="title">
        <!-- !allStatus[el.auth] -->
        <a-checkbox
          :indeterminate="!allStatus[el.auth]"
          :checked="all[el.auth].length != 0"
          @change="(e) => onCheckAllChange(e, index)"
        >
          {{ el.title }}
        </a-checkbox>
      </div>
      <a-divider type="vertical" />
      <a-checkbox-group
        v-model="all[el.auth]"
        :options="filterData(el.children)"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import { roleDetail } from "@/api/index/system";
import { menuList } from "@/config/routerConfig";

export default {
  name: "role",
  props: {
    roleValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      all: {},
      allStatus: {},
      menuList,
    };
  },
  created() {},
  methods: {
    // 初始化 this.all的数据, 可用来清空数据
    createAllItem() {
      this.menuList?.forEach((el) => {
        const { auth } = el;
        if (auth) {
          this.$set(this.all, auth, []);
          this.$set(this.allStatus, auth, true);
        }
      });
      //console.log(this.allStatus);
    },
    // 根据 value 的 auth 给 this.all[auth]设置数据
    setAllItemValue(value) {
      // 回显数据
      // auth_name 格式
      this.createAllItem();
      if (!value) return false;
      value?.split(";")?.forEach((el) => {
        const auth = el.split("_")?.[0];
        if (!auth) return false;
        this.all[auth].push(el);
      });
      //console.log(this.all);
      // 修改全选状态
      // 判断 this.all[el]的数据是否 === this.menuList[?].children
      Object.keys(this.all).forEach((el) => {
        const item = this.all?.[el];
        if (!item?.length) return false;
        const children = this.menuList.find((elm) => elm.auth === el)?.children;
        if (!children?.length || item.length !== children.length) return false;

        this.allStatus[el] = true;
      });
    },
    // 根据id获取详情，并设置role值
    roleInit: async function (roleId) {
      if (this.loading) return false;
      this.loading = true;
      const res = await roleDetail(roleId);
      this.loading = false;
      this.setAllItemValue(res?.resultData?.resources);
    },
    onCheckAllChange(e, index) {
      console.log(e, index);
      const checked = e.target.checked;
      const item = menuList?.[index];
      const auth = item?.auth;
      const children = item?.children || [];
      if (!auth) return false;
      this.all[auth] = checked ? children.map((el) => el.auth) : [];
      //this.allStatus[auth] = checked;
      this.$emit("role-change", this.all);
    },
    filterData(data) {
      if (!data || !data.length) return [];
      return data.map((el) => {
        const { title, auth } = el;
        return {
          ...el,
          label: title,
          value: auth,
        };
      });
    },
    onChange(e) {
      Object.keys(this.all).forEach((el) => {
        const item = this.all?.[el];
        if (!item?.length) return false;
        const children = this.menuList.find((elm) => elm.auth === el)?.children;
        if (!children?.length || item.length !== children.length) return false;
        this.allStatus[el] = true;
        // if (len == this.menuList?.el?.children?.length) {
        //   console.log(111);
        //   this.allStatus[el] = false;
        // } else {
        //   console.log(2222);
        //   this.allStatus[el] = true;
        // }
      });
      this.$emit("role-change", this.all);
    },
  },
  watch: {
    roleValue: {
      handler() {
        this.setAllItemValue(this.roleValue);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="less">
.role_list {
  display: flex;
  padding: 10px;

  .title {
    min-width: 150px;
  }
}

.add_role {
  width: 100px;
  height: 30px;
  font-size: 12px;
  border: none;
  background-color: #2a82e4;
  border-radius: 5px;
  color: #fff;
  outline: none;
}
::v-deep .ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.65);
  cursor: not-allowed;
}
::v-deep .ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {
  /* background-color: rgba(0, 0, 0, 0.25); */
  /* border-color: rgba(0, 0, 0, 0.25); */
  background-color: #0082ff;
}
</style>
